import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({
  size = 'md',
  showText = true,
  clickable = false,
  className = ''
}) => {
  const navigate = useNavigate();

  const sizes = {
    xs: { sphere: 'w-3 h-3', text: 'text-sm', gap: 'gap-1.5' },
    sm: { sphere: 'w-4 h-4', text: 'text-lg', gap: 'gap-2' },
    md: { sphere: 'w-5 h-5', text: 'text-xl', gap: 'gap-2.5' },
    lg: { sphere: 'w-6 h-6', text: 'text-2xl', gap: 'gap-3' },
    xl: { sphere: 'w-8 h-8', text: 'text-3xl', gap: 'gap-3' }
  };

  const { sphere, text, gap } = sizes[size] || sizes.md;

  const content = (
    <div className={`flex items-center ${gap} ${className}`}>
      
      {/* Premium Blue Orb */}
      <div
        className={`${sphere} rounded-full shrink-0`}
        style={{
          background:
            'radial-gradient(circle at 30% 30%, #93c5fd, #3b82f6 45%, #1d4ed8 70%, #1e3a8a)',
          boxShadow:
            '0 0 18px rgba(59,130,246,.75), 0 0 36px rgba(59,130,246,.35)'
        }}
      />

      {showText && (
        <span
          className={`font-serif font-semibold tracking-wide ${text}`}
          style={{
            background:
              'linear-gradient(90deg,#fff7cc,#facc15,#fde68a,#ffffff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          AskUniverse
        </span>
      )}
    </div>
  );

  if (clickable) {
    return (
      <button
        onClick={() => navigate('/')}
        className="hover:opacity-90 transition duration-300"
        data-testid="logo-btn"
      >
        {content}
      </button>
    );
  }

  return content;
};

export default Logo;
